import { graphql } from "msw";
import { mockCart, mockCartOrderSummary } from "./mockCart";
import {
  RemoveCouponFromCartMutationVariables,
  RemoveCouponFromCartMutation,
} from "@cart-app/generated/graphql";

export const handler = graphql.mutation<
  RemoveCouponFromCartMutation,
  RemoveCouponFromCartMutationVariables
>("RemoveCouponFromCart", (req, res, ctx) => {
  const newTotal =
    mockCartOrderSummary.totalPrice.amount +
    (mockCartOrderSummary?.discounts?.[0].discount.amount || 0);

  return res(
    ctx.data({
      removeCouponFromCart: {
        __typename: "Cart" as const,
        ...mockCart,
        userCoupon: null,
        orderSummary: {
          ...mockCartOrderSummary,
          discounts: [],
          totalPrice: { __typename: "Money" as const, amount: newTotal },
        },
      },
    })
  );
});
